var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.iframeSrc )?_c('iframe',{attrs:{"src":_vm.iframeSrc,"width":"100%","height":"100%","allow":"microphone; camera; fullscreen"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }